<template>
    <div class="home-hero-slider__girl">
        <svg>
          <defs>
            <!-- Wave for mask and layout  fill='#FFF'-->
            <g id="wave">
              <svg viewBox="0 0 123 768" preserveAspectRatio="none" width="6.1%" height="100%" x="0" y="0">
                <g transform="translate(-1087.000000, 0.000000)">
                  <g transform="translate(0.000000, -91.000000)">
                    <path fill="url(#TremfyaGradientWave)" d="M1087.7,91h122.8v768h-3.7c6.8-117.2-10-241.5-50.4-373.1S1093.1,222.7,1087.7,91z"/>
                  </g>
                </g>
              </svg>
              <rect x='6%' y='0' width='115%' height='100%' fill="url(#TremfyaGradientBody)" />
            </g>

            <!-- Tremfya blue gradient -->
            <linearGradient id="TremfyaGradientWave" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#00C7C7" />
              <stop offset="100%" stop-color="#00BCB8" />
            </linearGradient>
            <linearGradient id="TremfyaGradientBody" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#00BCB8" />
              <stop offset="100%" stop-color="#00B2AA" />
            </linearGradient>
          </defs>

          <!-- Add mask outside defs for control unit -->
          <mask id="mask" x="0" y="0" width="100%" height="100%">
            <use :x="waveOverlayOffsetX" y="0" xlink:href="#wave" ref="mask" />
          </mask>

          <!-- Wave overlay -->
          <use 
            v-if="initWave"
            :x="waveOverlayOffsetX" 
            y="0" xlink:href="#wave" ref="maskOverlay" />
          <svg 
            v-if="userAgent.device.isMobile === false"
            :x="mouseSwipeX" 
            width="29px" height="29px" 
            viewBox="0 0 29 29" 
            y="49%" 
            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
            class="home-hero-slider__wave-swipe">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-1113.000000, -274.000000)">
                    <g transform="translate(0.000000, -91.000000)">
                        <g transform="translate(1113.000000, 365.000000)">
                            <circle fill="#FFFFFF" cx="14.5" cy="14.5" r="14.5"></circle>
                            <g transform="translate(9.000000, 7.000000)" fill="#8000FF">
                                <g class="home-hero-slider__wave-swipe--mouse">
                                <path d="M5.50001537,1 C3.01876112,1 1,2.95878303 1,5.36640506 L1,9.63359494 C1,12.041217 3.01876112,14 5.50001537,14 C7.98142334,14 10,12.0486801 10,9.6501308 L10,5.36640506 C10,2.95878303 7.98142334,1 5.50001537,1 Z M5.50001525,15 C2.46724838,15 0,12.5937012 0,9.63591797 L0,5.36422852 C0,2.40644531 2.46724838,0 5.50001525,0 C8.53259908,0 11,2.40644531 11,5.36422852 L11,9.65232422 C11,12.6009961 8.53259908,15 5.50001525,15 Z"></path>
                                <path d="M5,6.45453376 L5,4.54546624 C5,4.2441954 5.22384758,4 5.50001475,4 C5.77618191,4 6,4.2441954 6,4.54546624 L6,6.45453376 C6,6.75583677 5.77618191,7 5.50001475,7 C5.22384758,7 5,6.75583677 5,6.45453376 Z"></path>
                                </g>
                            </g>
                            <g transform="translate(3.000000, 11.000000)" fill="#8000FF" stroke="#FFFFFF">
                                <polygon points="19 0 22.6694336 2.80091664 19 6"></polygon>
                                <polygon transform="translate(1.834717, 3.000000) rotate(180.000000) translate(-1.834717, -3.000000) " points="0 0 3.66943359 2.80091664 0 6"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
              </g>
          </svg>

          <!-- Girl -->
          <g>
            <svg
              :x="girlX + '%'"
              class="home-hero__girl">
              <image 
                v-if="!userAgent.device.isMobile"
                v-bind="{'xlink:href': girlImg[0]}"
                preserveAspectRatio="xMidYMax meet"
                xmlns:xlink= "http://www.w3.org/1999/xlink" 
                width="120%" height="120%" 
                x="-9%" y="-20%" />
              <image 
                v-else
                v-bind="{'xlink:href': girlImg[0]}"
                preserveAspectRatio="xMidYMax meet"
                xmlns:xlink= "http://www.w3.org/1999/xlink" 
                width="100%" height="100%" 
                x="0" y="0" />
              <image 
                v-if="!userAgent.device.isMobile"
                v-bind="{'xlink:href': girlImg[1]}"
                preserveAspectRatio="xMidYMax meet"
                xmlns:xlink= "http://www.w3.org/1999/xlink" 
                width="120%" height="120%" 
                x="-9%" y="-20%"
                mask="url(#mask)" />
              <image 
                v-else
                v-bind="{'xlink:href': girlImg[1]}"
                preserveAspectRatio="xMidYMax meet"
                xmlns:xlink= "http://www.w3.org/1999/xlink" 
                width="100%" height="100%" 
                x="0" y="0"
                mask="url(#mask)" />
            </svg>
          </g>
        </svg>
    </div>
</template>

<script>
import { TweenMax, TimelineMax, Power0, Sine } from 'gsap';
import { mapState } from 'vuex';

TweenMax.defaultEase = Power0.easeNone;

let tl;
let girlTL;

let easeMode = Sine;

export default {
  props: {
    mouseX: Number,
    clickSwitch: Number,
    initWave: Boolean
  },
  data() {
    return {
      timelinePercent: 0,
      waveOverlayOffsetX: 0,
      timelineAnimated: false,
      waveInited: false,
      girlX: 0,
      playPsoriasisTitle: false,
      playTremfyaTitle: false,
      waveState: 0 // 0 - Psoriasis, 1 - Tremfya
    };
  },
  computed: {
    ...mapState(['userAgent']),
    docW() {
      return this.userAgent.window.width;
    },
    mouseSwipeX() {
      // return parseInt(this.waveOverlayOffsetX + this.docW * 0.026);
      return parseInt(this.waveOverlayOffsetX + this.docW * 0.035 - 16);
    },
    switchVal() {
      return this.clickSwitch;
    },
    girlImg() {
      let res = ['', ''];

      if (this.docW > 1920) {
        res[0] =
          'https://res.cloudinary.com/haymarket-pri/image/upload/c_scale,w_1000/v1543840793/janssen_tremfya_fp/WomanPsoriasis_MQ.png';
        res[1] =
          'https://res.cloudinary.com/haymarket-pri/image/upload/c_scale,w_1000/v1543840795/janssen_tremfya_fp/WomanTremfya_MQ.png';
      } else {
        res[0] =
          'https://res.cloudinary.com/haymarket-pri/image/upload/c_scale,w_800/v1543840793/janssen_tremfya_fp/WomanPsoriasis_MQ.png';
        res[1] =
          'https://res.cloudinary.com/haymarket-pri/image/upload/c_scale,w_800/v1543840795/janssen_tremfya_fp/WomanTremfya_MQ.png';
      }

      return res;
    },
    // girlY() {
    //   return this.userAgent.window.width >= 1025 ? 0 : '66%';
    //   // return this.userAgent.device.isMobile === false || this.userAgent.window.width >= 1025 ? 0 : '70%';
    // },
    girlSize() {
      return this.userAgent.window.width > 700 ? '100%' : '110%';
    }
  },
  watch: {
    waveState(val) {
      if (tl && this.initWave === true) {
        this.handleWaveState(val);
      }
    },
    playPsoriasisTitle() {
      this.$emit('toggle-play-title');
    },
    playTremfyaTitle() {
      this.$emit('toggle-play-title', false);
    },
    timelinePercent(newVal) {
      //console.log(newVal);

      if (!this.timelineAnimated) {
        const a = new TimelineMax();
        if (newVal <= 0.2) {
          a.set(this.$data, { timelineAnimated: true })
            .to(tl, 0.3, { progress: 0 })
            .set(this.$data, { timelineAnimated: false });
          return;
        }
        if (newVal >= 0.8) {
          a.set(this.$data, { timelineAnimated: true })
            .to(tl, 0.3, { progress: 1 })
            .set(this.$data, { timelineAnimated: false });
          return;
        }
        let animationSpeed =
          tl.progress() === 1 || tl.progress() === 0 ? 0.2 : 0;
        a.set(this.$data, { timelineAnimated: true })
          .to(tl, animationSpeed, { progress: newVal })
          .set(this.$data, { timelineAnimated: false });
      }
    },
    switchVal(val) {
      if (val === 1) {
        this.openPsoriasis();
      } else if (val === 2) {
        this.openTremfyafp();
      }
    },
    mouseX() {
      if (this.waveInited === true) {
        this.timelinePercent = this.mouseX / this.docW;
      }
    },
    initWave(val) {
      if (val === true) {
        if (this.userAgent.device.isMobile) {
          // if its mobile
          // document.querySelector('.hero-content--right').style.opacity = 0; // hide Tremfya text before anim
          // document.querySelector('.hero-content--right').style.visibility = 'hidden'; // hide Tremfya text before anim
          this.openPsoriasis();
        } else {
          this.animWaveInit();
        }
      }
    },
    docW(val) {
      if (
        this.userAgent.device.isMobile &&
        (this.switchVal === 0 || this.switchVal === 1)
      ) {
        this.waveOverlayOffsetX = val;
      }

      if (tl && this.initWave === true) {
        tl.set('.contentLeft .link-box', { clearProps: 'all' });

        // restart wave
        this.initTimeLine();
      }
    }
  },
  methods: {
    handleWaveState(val) {
      if (val === 0) {
        // Open Psoriasis
        this.playPsoriasisTitle = true;
        // this.playTremfyaTitle = false;
      } else if (val === 1) {
        // this.playPsoriasisTitle = false;
        this.playTremfyaTitle = true;
      }
      // else {
      //   this.playPsoriasisTitle = false;
      //   this.playTremfyaTitle = false;
      // }
    },
    animWaveInit() {
      // console.log('animWaveInit *** ');
      const initTL = new TimelineMax({
        onComplete: () => {
          this.$emit('toggle-content-hide');
          this.waveInited = true;
          this.initTimeLine();
          this.handleWaveState(0);
        }
      });

      this.$emit('toggle-content-hide');

      initTL
        .fromTo(
          this.$data,
          0.5,
          {
            waveOverlayOffsetX: this.docW,
            ease: Power0.easeNone
          },
          {
            waveOverlayOffsetX: parseInt(this.docW * 0.8),
            ease: Power0.easeNone
          }
        )

        // animate
        .fromTo(
          '.contentRight + h3',
          0.5,
          { opacity: 0, x: 100 },
          { opacity: 1, x: 0 },
          0.8
        )
        .fromTo(
          '.contentLeft .box > .sign',
          0.3,
          { opacity: 0, x: -100 },
          { opacity: 1, x: 0 },
          0.2
        )
        .fromTo(
          '.contentLeft h2',
          0.4,
          { opacity: 0, x: -100 },
          { opacity: 1, x: 0 },
          0.2
        )
        .fromTo(
          '.contentLeft .learn-more',
          0.5,
          { opacity: 0, x: -100 },
          { opacity: 1, x: 0 },
          0.2
        )
        .fromTo(
          '.contentLeft .bg-letter',
          0.8,
          { opacity: 0, x: -100 },
          { opacity: 0.12, x: 0 },
          0.2
        );
    },
    openPsoriasis() {
      girlTL = new TimelineMax({
        onStart: () => {
          document.querySelector('.hero-content--right').style.display = 'none';
        }
      });

      this.playPsoriasisTitle = false;

      girlTL
        .set('.hero-content--left', { clearProps: 'all' })
        .to(this.$data, 1, {
          girlX: -50,
          waveOverlayOffsetX: this.docW
        })
        .fromTo(
          '.hero-content--left',
          1,
          { opacity: 0, x: this.docW / 2 },
          { opacity: 1, x: 0 },
          1
        )
        .to(this.$data, 0, { playPsoriasisTitle: true }, 2)
        .to('.hero-content--right', 0.3, { opacity: 0, y: -50 }, 0)
        // .to('.hero-content--right', 0, { x: 500 }, 0.3)
        .to('.content-switch--left', 0.5, { opacity: 0, left: -24 }, 0)
        .to('.content-switch--right', 0.5, { opacity: 1, right: 0 }, 2);

      if (this.userAgent.screentest) {
        girlTL.progress(1);
      }
    },
    openTremfyafp() {
      girlTL = new TimelineMax({
        onStart: () => {
          document.querySelector('.hero-content--left').style.display = 'none';
        }
      });

      this.playTremfyaTitle = false;

      girlTL
        .set('.hero-content--right', { clearProps: 'all' })
        .to(this.$data, 1, {
          girlX: 50,
          waveOverlayOffsetX: this.docW * -0.15
        })
        .fromTo(
          '.hero-content--right',
          1,
          { opacity: 0, x: -this.docW / 2 },
          { opacity: 1, x: 0 },
          1
        )
        .to(this.$data, 0, { playTremfyaTitle: true }, 2)
        .to('.hero-content--left', 0.3, { opacity: 0, y: -50 }, 0)
        // .to('.hero-content--left', 0, { x: -500 }, 0.3)
        .to('.content-switch--left', 0.5, { opacity: 1, left: 0 }, 2)
        .to('.content-switch--right', 0.5, { opacity: 0, right: -24 }, 0);

      if (this.userAgent.screentest) {
        girlTL.progress(1);
      }
    },
    initTimeLine() {
      tl = new TimelineMax({ paused: true });
      tl.fromTo(
        this.$data,
        1,
        {
          waveOverlayOffsetX: parseInt(this.docW * 0.8),
          ease: easeMode.easeInOut
        },
        {
          waveOverlayOffsetX: parseInt(this.docW * 0.1),
          ease: easeMode.easeInOut
        }
      )
        .fromTo(
          this.$data,
          0.5,
          {
            waveState: 0
          },
          {
            waveState: 1
          },
          0
        )

        // sign
        .fromTo(
          '.contentRight > .box > .sign',
          0.3,
          { opacity: 0, x: 100 },
          { opacity: 1, x: 0 },
          0.2
        )
        .fromTo(
          '.contentLeft > .box > .sign',
          0.2,
          { opacity: 1, x: 0 },
          { opacity: 0, x: -100 },
          0.52
        )

        // title
        .fromTo(
          '.contentRight h2',
          0.2,
          { opacity: 0, x: 100 },
          { opacity: 1, x: 0 },
          0.25
        )
        .fromTo(
          '.contentLeft h2',
          0.2,
          { opacity: 1, x: 0 },
          { opacity: 0, x: -100 },
          0.55
        )

        // BG transparent letter
        .fromTo(
          '.contentRight .bg-letter',
          0.2,
          { opacity: 0, x: 100 },
          { opacity: 0.12, x: 0 },
          0.22
        )
        .fromTo(
          '.contentLeft .bg-letter',
          0.2,
          { opacity: 0.12, x: 0 },
          { opacity: 0, x: -100 },
          0.58
        )

        // Link - learn more
        .fromTo(
          '.contentRight .learn-more',
          0.2,
          { opacity: 0, x: 100 },
          { opacity: 1, x: 0 },
          0.32
        )
        .fromTo(
          '.contentLeft .learn-more',
          0.2,
          { opacity: 1, x: 0 },
          { opacity: 0, x: -100 },
          0.58
        )

        // link box
        .fromTo(
          '.contentRight .link-box',
          0.2,
          { x: '100%' },
          { x: '0%' },
          0.32
        )
        .fromTo('.contentLeft .link-box', 0.2, { x: 0 }, { x: '-100%' }, 0.58)

        // collapsed content title
        .fromTo(
          '.contentRight + h3',
          0.3,
          { opacity: 1, x: 0 },
          { opacity: 0, x: 100 },
          0.15
        )
        .fromTo(
          '.contentLeft + h3',
          0.2,
          { opacity: 0, x: -100 },
          { opacity: 1, x: 0 },
          0.7
        );
    }
  },
  mounted() {
    let hookIndex = this.$store.state.girlWaveNavGuardIndex; // nav guard hook index

    this.waveOverlayOffsetX = this.docW; // move wave outside viewport

    if (hookIndex >= 0) {
      this.$router.beforeHooks.splice(hookIndex, 1); // remove old hook
    }

    this.$router.beforeEach((to, from, next) => {
      // console.log('to', to);
      // console.log('from', from);
      // console.log('***');
      // next();

      // if(this.waveState === 0 || this.waveState === 1){
      // waveState: 0 // 0 - Psoriasis, 1 - Tremfya

      if (from.name === 'Home') {
        let tween = new TimelineMax({
          onStart: () => {
            this.lockScroll();
            this.$store.commit('setTransitionAnimated', true);
            document.body.classList.add('block-pointer-events');
          },
          onComplete: () => {
            this.$store.commit('setTransitionAnimated', false);
            document.body.classList.remove('block-pointer-events');
            this.unlockScroll();
            next();
          }
        });
        let toPsoriasis = to.name.includes('Psoriasis') ? true : false;
        let waveX = toPsoriasis ? this.docW : this.docW * -0.1;

        this.waveInited = false; // stop move wave by mouse

        tween.to(
          '.contentRight + h3',
          0.5,
          {
            x: 100,
            opacity: 0
          },
          0
        );
        tween.to(
          '.contentLeft + h3',
          0.5,
          {
            x: -100,
            opacity: 0
          },
          0
        );

        tween.staggerTo(
          '.contentLeft  > .box > * ',
          0.5,
          {
            x: 100,
            opacity: 0
          },
          0.1,
          0
        );
        tween.staggerTo(
          '.contentRight  > .box > * ',
          0.5,
          {
            x: -100,
            opacity: 0
          },
          0.1,
          0
        );
        tween.to('.home-hero__girl', 0.5, { opacity: 0 }, 0);
        tween.to(this.$data, 0.5, { waveOverlayOffsetX: waveX }, '+=0');
      } else {
        next();
      }
    });
    this.$store.commit(
      'setGirlWaveNavGuardIndex',
      this.$router.beforeHooks.length - 1
    );

    // console.log( 'router.beforeHooks', gWaveHook, (this.$router.beforeHooks[1] == gWaveHook), (this.$router.beforeHooks[1] == gWaveHook) );
  }
  // beforeRouteLeave (to, from, next) {
  //   // called when the route that renders this component is about to
  //   // be navigated away from.
  //   // has access to `this` component instance.
  //   console.log('Before leave HomeHero');
  //   next();
  // }
};
</script>
